import { EnumSchema, Executor, FromSchema } from '@40seas/entities/common';
import { BaseEntity, WithBaseEntitySchema } from '@40seas/models';
import { z } from 'zod';
import { CreditSafePortfolioCompanyStatus } from './credit-safe.portfolio-company.status';

export const CreditSafePortfolioCompanySchema = WithBaseEntitySchema(
    z.object({
        portfolioId: z.string(),
        connectionId: z.string(),
        status: EnumSchema(CreditSafePortfolioCompanyStatus),
        buyer: z.string(),
    }),
).strict();

export class CreditSafePortfolioCompany extends FromSchema(CreditSafePortfolioCompanySchema) implements BaseEntity {
    id: string;
    portfolioId: string;
    connectionId: string;
    status: CreditSafePortfolioCompanyStatus;
    buyer: string;
    createdAt: Date;
    updatedAt: Date;
    tenantId: string;
    createdBy?: Executor;
    seller?: string;
    metadata?: { [key: string]: string };
    timeline?: { [status: string]: { updatedAt: Date } };
}
